import { makeAutoObservable, observable, ObservableMap } from "mobx";
import { DEBUG_BOOKMARKS } from "../../lib/debug";
export class Bookmark {
    constructor(uid, key, starred) {
        Object.defineProperty(this, "uid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "key", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "starred", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeAutoObservable(this);
        this.uid = uid;
        this.key = key;
        this.starred = starred;
    }
    toJSON() {
        return {
            uid: this.uid,
            key: this.key,
            starred: this.starred
        };
    }
}
export class Bookmarks {
    constructor({ db }) {
        // Map of document Key to an array of bookmarks
        Object.defineProperty(this, "bookmarkMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new ObservableMap()
        });
        Object.defineProperty(this, "db", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeAutoObservable(this);
        this.db = db;
    }
    isDocumentBookmarked(docKey) {
        var _a;
        return !!((_a = this.bookmarkMap.get(docKey)) === null || _a === void 0 ? void 0 : _a.find(bookmark => bookmark.starred));
    }
    isDocumentBookmarkedByUser(docKey, uid) {
        var _a;
        return !!((_a = this.getDocumentUserBookmark(docKey, uid)) === null || _a === void 0 ? void 0 : _a.starred);
    }
    getOrCreateDocumentBookmarks(docKey) {
        const docBookmarks = this.bookmarkMap.get(docKey);
        if (docBookmarks)
            return docBookmarks;
        const newDocBookmarks = observable.array();
        this.bookmarkMap.set(docKey, newDocBookmarks);
        return newDocBookmarks;
    }
    getDocumentUserBookmark(docKey, uid) {
        const docBookmarks = this.bookmarkMap.get(docKey);
        return docBookmarks === null || docBookmarks === void 0 ? void 0 : docBookmarks.find((bookmark) => bookmark.uid === uid);
    }
    getDocumentBookmark(docKey, bookmarkKey) {
        const docBookmarks = this.bookmarkMap.get(docKey);
        return docBookmarks === null || docBookmarks === void 0 ? void 0 : docBookmarks.find((bookmark) => bookmark.key === bookmarkKey);
    }
    updateDocumentBookmark(docKey, bookmark) {
        const existingBookmark = this.getDocumentBookmark(docKey, bookmark.key);
        if (existingBookmark) {
            if (existingBookmark.uid !== bookmark.uid) {
                console.warn("bookmarks: Trying to change the user of an existing bookmark", { docKey, existingBookmark: existingBookmark.toJSON(), newBookmark: bookmark.toJSON() });
                return;
            }
            existingBookmark.starred = bookmark.starred;
        }
        else {
            const docBookmarks = this.getOrCreateDocumentBookmarks(docKey);
            docBookmarks.push(bookmark);
        }
    }
    /**
     * If the document has a bookmark for this user, toggle its starred state.
     * If the document doesn't have a bookmark for this user, create one that
     * that is starred.
     *
     * @param docKey
     * @param userId
     * @returns
     */
    toggleUserBookmark(docKey, userId) {
        var _a;
        const userBookmark = this.getDocumentUserBookmark(docKey, userId);
        if (DEBUG_BOOKMARKS) {
            const allDocBookmarks = ((_a = this.bookmarkMap.get(docKey)) !== null && _a !== void 0 ? _a : []).map(bookmark => bookmark.toJSON());
            // eslint-disable-next-line no-console
            console.log("bookmarks: toggling bookmark", { docKey, userId, bookmarkKey: userBookmark === null || userBookmark === void 0 ? void 0 : userBookmark.key, allDocBookmarks });
        }
        if (userBookmark) {
            this.db.setUserStarState(docKey, userBookmark.key, !userBookmark.starred);
            return;
        }
        this.db.createUserStar(docKey, true);
    }
    // This is used for debugging
    getBookmarkLabel(docKey, currentUserId, classStore) {
        const docStars = this.bookmarkMap.get(docKey);
        if (!docStars)
            return "";
        const starOwners = { user: 0, teacher: 0, others: 0 };
        docStars.forEach(star => {
            if (!star.starred)
                return;
            if (star.uid === currentUserId) {
                starOwners.user++;
            }
            else if (classStore.isTeacher(star.uid)) {
                starOwners.teacher++;
            }
            else {
                starOwners.others++;
            }
        });
        const abbreviations = { user: "U", teacher: "T", others: "O" };
        return Object.entries(starOwners).map(([key, value]) => {
            if (value === 0)
                return "  ";
            return `${abbreviations[key]}${value}`;
        }).join(" ");
    }
}
//# sourceMappingURL=data:application/json;base64,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